/**
 * Configuration for 3D file loaders
 * Defines thresholds and optimization strategies for different file sizes
 */

export const LoaderConfig = {
  // File size thresholds in bytes
  WORKER_THRESHOLD: 10 * 1024 * 1024, // 10MB - Use Web Worker
  MAX_SPLIT_SIZE: 50 * 1024 * 1024, // 50MB - Maximum size for geometry splitting
} as const

/**
 * Determines the optimization strategy based on file size.
 *
 * Meshes are loaded at full resolution — no decimation. WebGL renders millions of
 * triangles fine, and slicing runs on the raw geometry server-side, so display-time
 * simplification is unnecessary (and the previous simplifier produced bad results).
 */
export function getOptimizationStrategy(fileSize: number) {
  return {
    useWorker: fileSize >= LoaderConfig.WORKER_THRESHOLD,
    shouldSplit: fileSize <= LoaderConfig.MAX_SPLIT_SIZE,
  }
}
